import { TYPE_OF_TRANSACTION, MORTGAGE_TYPE } from '@modules/opportunities/entities/opportunity/const';
import { t as i18t } from 'i18next';

export const PROPOSAL_TRANSACTION_TYPE = [
  {
    label: i18t('clients.transactionDetails.transactionTypePrimary'),
    value: TYPE_OF_TRANSACTION.primary,
  },
  {
    label: i18t('clients.transactionDetails.transactionTypeResale'),
    value: TYPE_OF_TRANSACTION.resale,
  },
  {
    label: i18t('clients.transactionDetails.transactionTypeBuyoutEquity'),
    value: TYPE_OF_TRANSACTION.buyoutEquity,
  },
  {
    label: i18t('clients.transactionDetails.transactionTypeBuyout'),
    value: TYPE_OF_TRANSACTION.buyout,
  },
  {
    label: i18t('clients.transactionDetails.transactionTypeEquity'),
    value: TYPE_OF_TRANSACTION.equity,
  }
];

export const PROPOSAL_TRANSACTION_TYPE_CONSTRUCTION = [
  {
    label: i18t('clients.transactionDetails.transactionTypePrimary'),
    value: TYPE_OF_TRANSACTION.primary,
  },
  {
    label: i18t('clients.transactionDetails.transactionTypeResale'),
    value: TYPE_OF_TRANSACTION.resale,
  }
];

export const PROPOSAL_MORTGAGE_TYPE_OPTIONS = [
  {
    label: i18t('clients.mortgageDetails.mortgageTypeConventional'),
    value: MORTGAGE_TYPE.conventional,
  },
  {
    label: i18t('clients.mortgageDetails.mortgageTypeIslamic'),
    value: MORTGAGE_TYPE.islamic,
  },
  {
    label: i18t('clients.mortgageDetails.mortgageTypeBestRate'),
    value: MORTGAGE_TYPE.bestRate,
  }
];

export const PROPOSAL_EXISTING_MORTGAGE_TYPE_OPTIONS = [
  {
    label: i18t('clients.mortgageDetails.mortgageTypeConventional'),
    value: MORTGAGE_TYPE.conventional,
  },
  {
    label: i18t('clients.mortgageDetails.mortgageTypeIslamic'),
    value: MORTGAGE_TYPE.islamic,
  }
];
